<i18n src="@/lang/actions.json"></i18n>
<i18n>
    {
    "en": {
    "table": {
    "operations": "Operations",
    "name": "Name",
    "customer": "Customer",
    "amocrm": "AmoCRM",
    "locale": "Language"
    },
    "message": {
    "copied": "Copied success",
    "copied_error": "Can not copy",
    "copied_empty": "Text empty. Choose settings"
    }
    },
    "ua": {
    "table": {
    "operations": "Дії",
    "name": "Назва",
    "customer": "Клієнт",
    "amocrm": "AmoCRM",
    "locale": "Мова"
    },
    "message": {
    "copied": "Скопійовано до буферу",
    "copied_error": "Не вдалося скопіювати",
    "copied_empty": "Текст попрожній. Оберіть параметри"
    }
    },
    "ru": {
    "table": {
    "operations": "Действия",
    "name": "Название",
    "customer": "Клиент",
    "amocrm": "AmoCRM",
    "locale": "Локаль"
    },
    "message": {
    "copied": "Скопирован в буфер",
    "copied_error": "Не получилось скопировать",
    "copied_empty": "Текст пустой. Выберите параметры"
    }
    }
    }
</i18n>

<template>
  <el-main>
    <el-header class="actions" v-show="!$route.params.name">
      <el-row type="flex" class="row-bg" justify="start">
        <el-col :span="12" style="display: flex; justify-content: start">
          <span style="margin-right: 10px">{{ $t("table.locale") }}</span>
          <el-select v-model="language" size="mini" style="width: 75px">
            <el-option
              v-for="l in Object.keys($i18n.messages)"
              :key="l"
              :label="l"
              :value="l"
            />
          </el-select>
        </el-col>
        <el-col :span="12" style="display: flex; justify-content: start">
          <span style="margin-right: 10px">{{ $t("table.customer") }}</span>
          <el-select v-model="customer_uuid" size="mini" filterable clearable>
            <el-option
              v-for="cust in customers"
              :key="cust.uuid"
              :label="cust.name"
              :value="cust.uuid"
            />
          </el-select>
        </el-col>
        <template v-if="customer && amocrm instanceof Array && amocrm.length">
          <el-col :span="12" style="display: flex; justify-content: start">
            <span style="margin-left: 20px; margin-right: 10px">{{
              $t("table.amocrm")
            }}</span>
            <el-select v-model="amo_uuid" size="mini" filterable clearable>
              <el-option
                v-for="amo in amocrm"
                :key="amo.uuid"
                :label="amo.domain"
                :value="amo.uuid"
              />
            </el-select>
          </el-col>
        </template>
        <el-col :span="12" style="display: flex; justify-content: start">
          <span style="margin-right: 10px">{{ $t("table.widgets") }}</span>
          <el-select v-model="widget_uuids" size="mini" multiple collapse-tags>
            <el-option
              v-for="widget in widgets"
              :key="widget.uuid"
              :label="widget.name.replace(/<[^>]+>/gi, '')"
              :value="widget.uuid"
            />
          </el-select>
        </el-col>
      </el-row>
    </el-header>
    <br />
    <el-table :data="embedded" v-show="!$route.params.name">
      <el-table-column :label="$t('table.name')" :width="150">
        <template slot-scope="scope">
          <router-link
            tag="span"
            :to="{
              name: 'embedded',
              params: { name: scope.row.name },
              query: { ..._data }
            }"
            style="cursor: pointer"
            v-if="scope.row.complete"
            >{{ $t(scope.row.name) }}
          </router-link>
          <span v-else>{{ $t(scope.row.name) }}</span>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <span v-if="scope.row.complete">{{
            $t(scope.row.embeddedText)
          }}</span>
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('table.operations')" align="right">
        <template slot-scope="scope">
          <el-dropdown
            split-button
            size="small"
            type="info"
            trigger="click"
            @click="handleCopy(scope.row)"
          >
            {{ $t("actions.copy") }}
            <el-dropdown-menu>
              <router-link
                v-if="scope.row.complete"
                :to="{ name: 'embedded', params: { name: scope.row.name } }"
              >
                <el-dropdown-item>{{ $t("actions.view") }}</el-dropdown-item>
              </router-link>
              <span v-else>
                <el-dropdown-item disabled>{{
                  $t("actions.view")
                }}</el-dropdown-item>
              </span>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <component
      :is="require('./elements/show_embedded').default"
      v-if="$route.params.name"
    />
  </el-main>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "embedded_index",
  data() {
    return {
      customer_uuid: "",
      amo_uuid: "",
      language: "",
      widget_uuids: []
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      Object.assign(vm._data, to.query);
    });
  },
  beforeRouteUpdate(to, from, next) {
    Object.assign(this._data, this.$route.query);
    next();
  },
  created() {
    this.setCustomer(null);
    this.setCustomerAttr(null);
    this.setAmocrmAttr(null);
    this.getCustomersList();
    this.getWidgetsList();
    this.language = this.locale;
  },
  watch: {
    customer_uuid(n, o) {
      if (n === o) {
        return;
      }
      this.$api
        .query({
          query: require("../../graphql/customers/customer.graphql"),
          variables: { uuid: n }
        })
        .then(() => {
          try {
            this.setCustomerAttr(n);
            this.amo_uuid = this.amocrm[0].uuid;
          } catch (e) {}
        });
    },
    amo_uuid(n, o) {
      if (n === o) {
        return;
      }
      this.setAmocrmAttr(n);
    },
    language(n) {
      this.setLocaleAttr(n);
    },
    widget_uuids(n, o) {
      this.setWidgetsAttr(n);
    }
  },
  methods: {
    ...mapMutations({
      setCustomer: "shared_customers/setData",
      setAmocrmAttr: "embedded/setAmocrmAttr",
      setCustomerAttr: "embedded/setCustomerAttr",
      setLocaleAttr: "embedded/setLocaleAttr",
      setWidgetsAttr: "embedded/setWidgetsAttr"
    }),
    getCustomersList() {
      return this.$api.query({
        query: require("../../graphql/customers/customers_list.graphql")
      });
    },
    getWidgetsList() {
      return this.$api.query({
        query: require("../../graphql/widgets/widgets_list.graphql"),
        variables: {
          filter: {
            enabled: true
          }
        }
      });
    },
    handleCopy(embedded) {
      this.$copyText(embedded.complete ? embedded.embeddedText : " ").then(
        e => {
          this.$message({
            message: embedded.complete
              ? this.$t("message.copied")
              : this.$t("message.copied_empty"),
            type: "success"
          });
        },
        e => {
          this.$message({
            message: this.$t("message.copied_error"),
            type: "error"
          });
        }
      );
    }
  },
  computed: {
    ...mapGetters({
      embedded: "embedded/embedded",
      customers: "shared_customers_list/customers",
      customer: "shared_customers/customer",
      amocrm: "shared_customers/amocrm",
      locale: "locale",
      widgets: "shared_widgets_list/widgets"
    })
  }
};
</script>

<style scoped lang="stylus">
.actions {
    justify-content: flex-start;
}

.widget-info-block-card {
    width: 300px;
    margin: 0 auto 10px;
}

.widget-info-block {
    display: flex;
}

.logo-small {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    margin-right: 10px;
}
</style>
